<template>
  <div class="course-validity-edit">
    <div class="title">基本信息</div>
    <Form
      class="form"
      ref="form"
      :model="form"
      :rules="formRules"
      label-position="right"
      :label-width="120"
    >
      <FormItem label="用户账号：" prop="users">
        <Tag
          type="border"
          closable
          v-for="user in users"
          :key="user.id"
          @on-close="useRangeDelete(users, user.id)"
        >
          {{ user.mobile }}
        </Tag>
        <Button class="mar" type="default" @click="showSelectUser = true">
          <i class="ivu-icon ivu-icon-ios-add"></i>选择用户
        </Button>
      </FormItem>
      <FormItem label="课程：" prop="course_id">
        <Tag
          type="border"
          closable
          v-for="course in courses"
          :key="course.id"
          @on-close="useRangeDelete(courses, course.id)"
        >
          {{ course.title }}
        </Tag>
        <Button class="mar" type="default" @click="showSelectCourse = true">
          <i class="ivu-icon ivu-icon-ios-add"></i>选择课程
        </Button>
      </FormItem>
      <FormItem label="有效期：" prop="expired_at">
        <DatePicker
          v-model="form.expired_at"
          type="date"
          placement="bottom-end"
          placeholder="请选择有效期"
          style="width: 200px"
        />
      </FormItem>
      <FormItem label="订单编号：" prop="order_number">
        <Input
          v-model="form.order_number"
          placeholder="请输入订单编号，没有可不填"
          clearable
        >
        </Input>
      </FormItem>
      <FormItem>
        <Button
          class="btn-form btn-margin-right"
          type="primary"
          size="large"
          @click="onSave"
        >
          保存
        </Button>
      </FormItem>
    </Form>
    <Modal
      v-model="showSelectUser"
      title="选择用户"
      @on-ok="onConfirmSelectUser"
      @on-cancel="$refs.users.recoverSelectedItems(users)"
      width="800"
    >
      <StudentSelect ref="users" />
    </Modal>
    <Modal
      v-model="showSelectCourse"
      title="选择课程"
      @on-ok="onConfirmSelectCourse"
      @on-cancel="$refs.course.recoverSelectedItems(courses)"
      width="800"
    >
      <CourseSelect
        ref="course"
        selectType="single"
        :showCatagory="true"
      ></CourseSelect>
    </Modal>
  </div>
</template>

<script>
import CourseSelect from "@/components/GridSelect/CourseSelect";
import StudentSelect from "@/components/GridSelect/StudentSelect";

export default {
  name: "course-validity-edit",
  components: {
    CourseSelect,
    StudentSelect,
  },
  data() {
    return {
      showSelectCourse: false,
      showSelectUser: false,
      courses: [],
      users: [],
      form: {
        id: 0,
        expired_at: "",
        order_number: "",
        course_id: "",
        users: [],
      },
      formRules: {
        users: [{ required: true, message: "用户账号不能为空" }],
        course_id: [{ required: true, message: "课程不能为空" }],
        expired_at: [{ required: true, message: "有效期不能为空" }],
      },
    };
  },

  created() {
    this.courseValidityId = this.$route.query.id;
    if (this.courseValidityId) {
      this.requestDetail();
    }
  },
  methods: {
    useRangeDelete(aryData, id) {
      if (!aryData || !aryData.length) return;
      for (let i = 0; i < aryData.length; ++i) {
        if (aryData[i].id == id) {
          aryData.splice(i, 1);
          break;
        }
      }
    },
    onConfirmSelectCourse() {
      this.showSelectCourse = false;
      let list = this.$refs.course.getSelectList();
      this.courses = list;
      this.form.course_id = list[0].id;
    },
    onConfirmSelectUser() {
      this.showSelectUser = false;
      let list = this.$refs.users.getSelectList();
      this.users = list;
      this.form.users = list.map((item) => ({
        id: item.uid,
        mobile: item.mobile,
      }));
    },
    onSave() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }

        this.$http.post("/api/validity/course_validity", this.form).then(() => {
          this.$Message.success("保存成功");
          setTimeout(() => {
            this.$router.back();
          }, 1000);
        });
      });
    },
    requestDetail() {
      this.$http
        .get("/api/validity/course_validity/" + this.courseValidityId)
        .then((data) => {
          this.form = data;
          const course = {
            id: data.course_id,
            title: data.course_name,
          };
          const user = {
            id: data.user_id,
            mobile: data.user_mobile,
          };
          this.form.expired_at = new Date(data.expired_at * 1000);
          this.courses = [course];
          this.users = [user];
          this.form.users = this.users;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.course-validity-edit {
  .form {
    width: 500px;
  }
  .ivu-form-item {
    width: 620px;
    .ivu-form-item-content {
      span {
        float: right;
      }
    }
  }
  .introduction {
    width: 500px;
  }
  .btn-form {
    width: 100px;
  }
  .btn-select-student {
    position: absolute;
    top: 1px;
    left: 400px;
  }
}
</style>
